import React from 'react';
import Prior from '../components/Prior';
import TrustCompany from '../components/TrustCompany';
import Component_one from '../components/Component_one';
import Card_one from '../components/Card_one';
import Card_two from '../components/Card_two';
import Card_three from '../components/Card_three';
import Travel from '../components/Travel';
import Footer from '../components/Footer';
import OurPartner from '../components/OurPartner';
import WhyChooseUs from '../components/WhyChooseUs';
import Stats from '../components/Stats';
import CorporateTravel from '../components/CorporateTravel';
import WhatWeOffer from '../components/WhatWeOffer';
import Journy from '../components/Journy';

function Home() {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '50px',
				marginTop: '80px',
			}}
		>
			<Prior />
			<TrustCompany />
			<Component_one />
			<Stats />
			{/* <OurPartner /> */}
			<CorporateTravel />
			<Card_one />
			<Card_two />
			<Card_three />
			<WhyChooseUs />
			<WhatWeOffer />
			<Journy />
			{/* <Travel /> */}
			<Footer />
		</div>
	);
}

export default Home;
